<template>
  <Notification
    :description="$t('rc_rate_unavailability_notification', { ConnectivityProvider: providerName })"
    v-bind="$attrs"
  >
    <template #ctaContent>
      <button
        class="tw:whitespace-nowrap tw:cursor-pointer tw:text-blue-700 tw:font-bold tw:hover:underline"
        type="button"
        @click="isLearnMoreOpen = true"
      >
        {{ $t('rc_notifications_cta_learn_more') }}
      </button>
    </template>
  </Notification>

  <CustomModal
    :is-modal-open="isLearnMoreOpen"
    :with-footer="true"
    custom-classes="tw:w-full tw:md:w-[620px]"
    overlay="dark"
    @toggleModal="isLearnMoreOpen = false"
    @onClickAway="isLearnMoreOpen = false"
  >
    <template #modalHeader>
      <h2 class="tw:text-xl tw:font-bold">
        {{ $t('rc_rate_check_cp_header', { ConnectivityProvider: providerName }) }}
      </h2>
    </template>

    <div class="tw:flex tw:flex-col tw:gap-6 tw:w-full">
      <RateCheckIssueContent
        :providerName="providerName"
        :partnerId="props.extraParameters?.partnerId"
        :contactUsUrl="contactUsUrl"
        variant="modal"
      />
    </div>

    <template #modalFooter>
      <div class="tw:ml-auto">
        <MainButton class="tw:min-w-[120px]" @click="isLearnMoreOpen = false">{{ $t('rc_rate_check_ok_cta') }}</MainButton>
      </div>
    </template>
  </CustomModal>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import Notification from '@/components/productNotifications/Notification.vue'
import CustomModal from '@/components/base/CustomModal.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'
import RateCheckIssueContent from '@/components/rateConnect/rateCheck/RateCheckIssueContent.vue'
import { getContactUrl } from '@/utils/Utility'
import { useSessionValues } from '@/composables/useSessionValues'
import { useConnectivityProviderName } from '@/composables/useConnectivityProviderName'
import { selectedAccommodationId } from '@/layouts/queries'

const props = defineProps<{
  extraParameters?: { partnerId?: number }
}>()

const { language, userId } = useSessionValues()
const isLearnMoreOpen = ref(false)

const { providerName } = useConnectivityProviderName(computed(() => props.extraParameters?.partnerId))

const contactUsUrl = computed(() =>
  selectedAccommodationId.value
    ? getContactUrl(language.value, userId.value ?? null, selectedAccommodationId.value, true)
    : undefined
)
</script>
